<am-topbar></am-topbar>
<div style="height: 100%; position: relative;">
  <div [@slideFadeinUp]="routeAnimation(outlet, 'slideFadeinUp')"
    [@slideFadeinRight]="routeAnimation(outlet, 'slideFadeinRight')"
    [@zoomFadein]="routeAnimation(outlet, 'zoomFadein')" [@fadein]="routeAnimation(outlet, 'fadein')">
    <div class="container">
      <router-outlet #outlet="outlet" (activate)="changeOfRoutes()"></router-outlet>
    </div>
  </div>
</div>
<am-footer></am-footer>